import React, { useState, useEffect, useContext } from "react";
import cn from "classnames";
import stylesCommon from "../common.module.scss";
import CustomLists from "../../custom/custom-lists/CustomLists";
import CustomButton from "../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/auth.context";
import { User } from "../../../services";
import { t } from "i18next";

export const USER_TYPE = {
  isCompany: "client",
  isCompanyTrans: "expeditor",
};

const RegistrationSurveyUser = ({ updateStep, setData, data, code }) => {
  const [userType, setUserType] = useState(data?.type || null);
  const [callNextStep, setCallNextStep] = useState(false);
  const [isCheck, setIsCheck] = useState(data.type === "client" || data.type === "expeditor" ? true : false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const items = [
    {
      text: t("registrationSurveyUserSecond.orgType.shipper"),
      summary: t("registrationSurveyUserSecond.orgType.shipperSummary"),
      value: USER_TYPE.isCompany,
    },
    {
      text: t("registrationSurveyUserSecond.orgType.transporter"),
      summary: t("registrationSurveyUserSecond.orgType.transporterSummary"),
      value: USER_TYPE.isCompanyTrans,
    },
  ];

  const activeChoiceIndex =
    data?.type === USER_TYPE.isCompany ? 0 : data?.type === USER_TYPE.isCompanyTrans ? 1 : null;

  const handleUserRoleChange = (selectedIndex) => {
    const selectedValue = items[selectedIndex].value;
    setData({ ...data, type: selectedValue, isHead: true });
    setIsCheck(true);
  };

  useEffect(() => {
    if (callNextStep) {
      nextStep();
      setCallNextStep(false);
    }
  }, [userType, callNextStep]);

  const nextStep = async () => {
    if (isCheck) {
      setIsLoading(true);
      try {
        const { isChecked, ...newData } = data;

        const response = await User.registerCN(newData);

        toast.success(t("registrationSurveyUserSecond.toast.registrationSuccess"));

        navigate("/login", {
          state: {
            username: response.data.eamil,
            password: response.data.password,
          },
        });
      } catch (error) {
        console.error("Ошибка при регистрации нового пользователя:", error);
        toast.error(t("registrationSurveyUserSecond.toast.registrationError"));
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className={stylesCommon.fullWidth}>
      <CustomLists
        items={items}
        isRadioBtn={true}
        onSelectionChange={handleUserRoleChange}
        activeChoice={activeChoiceIndex}
      />
      <div className={stylesCommon.mrXmedium}>
        <CustomButton
          isFall
          isLoading={isLoading}
          isDisabled={!isCheck}
          text={t("registrationSurveyUserSecond.button.login")}
          onClick={nextStep}
        />
      </div>
    </div>
  );
};

export default RegistrationSurveyUser;
